import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './HomePage.css';

const ViewFamily = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const existingFamily = location.state?.family;

  const [familyData, setFamilyData] = useState({
    familyName: '',
    contactAddress: '',
    landline: '',
    motherParish: '',
    prayerGroup: '',
    hofPhotoUrl: '',
    familyPhotoUrl: '',
    vehicleNumbers: [''],
    maps: ''
  });
  const [members, setMembers] = useState([]);

  useEffect(() => {
    if (existingFamily) {
      setFamilyData({
        familyName: existingFamily.familyName || '',
        contactAddress: existingFamily.contactAddress || '',
        landline: existingFamily.landline || '',
        motherParish: existingFamily.motherParish || '',
        prayerGroup: existingFamily.prayerGroup || '',
        hofPhotoUrl: existingFamily.hofPhotoUrl || '',
        familyPhotoUrl: existingFamily.familyPhotoUrl || '',
        vehicleNumbers: existingFamily.vehicleNumbers?.length ? existingFamily.vehicleNumbers : [''],
        maps: existingFamily.maps || ''
      });
      setMembers(existingFamily.members || []);
    }
  }, [existingFamily]);


  return (
    <div className="home-container">
      <header className="home-header">
        <div className="header-content">
          <div className="logo">
            <span className="cross-icon">✝</span>
            <h1>STMTC Admin Portal</h1>
          </div>
          <button onClick={() => navigate('/')} className="logout-btn">
            Back to Home
          </button>
        </div>
      </header>
      
      <main className="home-main">
        <div className="add-family-form">
          <h3>View Family Details</h3>
          <div className="form-section">
            <div className="form-row">
              <label className="form-label">Family Name</label>
              <div className="form-display">{familyData.familyName || 'N/A'}</div>
            </div>
            <div className="form-row">
              <label className="form-label">Contact Address</label>
              <div className="form-display">{familyData.contactAddress || 'N/A'}</div>
            </div>
            <div className="form-row">
              <label className="form-label">Landline</label>
              <div className="form-display">{familyData.landline || 'N/A'}</div>
            </div>
            <div className="form-row">
              <label className="form-label">Mother Parish</label>
              <div className="form-display">{familyData.motherParish || 'N/A'}</div>
            </div>
            <div className="form-row">
              <label className="form-label">Prayer Group</label>
              <div className="form-display">{familyData.prayerGroup || 'N/A'}</div>
            </div>
            <div className="form-row">
              <label className="form-label">HOF Photo</label>
              <div className="form-display">
                {familyData.hofPhotoUrl ? (
                  <img src={familyData.hofPhotoUrl} alt="Head of Family" className="photo-preview" />
                ) : (
                  'No photo available'
                )}
              </div>
            </div>
            <div className="form-row">
              <label className="form-label">Family Photo</label>
              <div className="form-display">
                {familyData.familyPhotoUrl ? (
                  <img src={familyData.familyPhotoUrl} alt="Family" className="photo-preview" />
                ) : (
                  'No photo available'
                )}
              </div>
            </div>
            <div className="form-row">
              <label className="form-label">Vehicle Numbers</label>
              <div className="form-display">
                {familyData.vehicleNumbers?.filter(v => v.trim()).length > 0 
                  ? familyData.vehicleNumbers.filter(v => v.trim()).join(', ')
                  : 'N/A'
                }
              </div>
            </div>
            <div className="form-row">
              <label className="form-label">Maps</label>
              <div className="form-display">{familyData.maps || 'N/A'}</div>
            </div>
          </div>

          <div className="members-section">
            <h4>Family Members</h4>
            {members.length > 0 ? (
              members.map((member, index) => (
                <div key={index} className="member-form">
                  <div className="member-header">
                    <h4>Member {index + 1}</h4>
                  </div>
                  <div className="form-row">
                    <label className="form-label">Full Name</label>
                    <div className="form-display">{member.fullName || 'N/A'}</div>
                  </div>
                  <div className="form-row">
                    <label className="form-label">Role</label>
                    <div className="form-display">{member.role || 'N/A'}</div>
                  </div>
                  <div className="form-row">
                    <label className="form-label">Relationship to HOF</label>
                    <div className="form-display">{member.relationshipToHof || 'N/A'}</div>
                  </div>
                  <div className="form-row">
                    <label className="form-label">Email</label>
                    <div className="form-display">{member.email || 'N/A'}</div>
                  </div>
                  <div className="form-row">
                    <label className="form-label">Phone Number</label>
                    <div className="form-display">{member.phoneNumber || 'N/A'}</div>
                  </div>
                  <div className="form-row">
                    <label className="form-label">Blood Group</label>
                    <div className="form-display">{member.bloodGroup || 'N/A'}</div>
                  </div>
                  <div className="form-row">
                    <label className="form-label">Date of Birth</label>
                    <div className="form-display">{member.dateOfBirth || 'N/A'}</div>
                  </div>
                  <div className="form-row">
                    <label className="form-label">Anniversary Date</label>
                    <div className="form-display">{member.anniversaryDate || 'N/A'}</div>
                  </div>
                </div>
              ))
            ) : (
              <div className="form-display">No members found</div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default ViewFamily;